module.exports = __webpack_public_path__ + "media/AUDIO 09.fb84d624.mp3";